module.exports = __webpack_public_path__ + "img/Circle.fd60aba1.png";